import css from "styled-jsx/css";
import { TABLET_QUERY_MAX_WIDTH } from "/constants/vp-sizes";
import colors from "/styles/colors";

export const componentStyles = css.global`
  .industry-selection-first-step-wrapper {
    display: flex;
    justify-content: center;

    .industry-selection-questions {
      display: flex;
      flex-direction: column;
      min-height: 80vh;

      .industry-question-wrapper {
        display: flex;
        align-items: center;
        flex-direction: column;
        padding-top: 15vh;
        transition: padding 0.2s;

        .industry-question {
          font-size: 1.375rem;
          padding-top: 8px;
          text-align: center;

          strong {
            font-weight: bold;
          }
        }

        .industry-selection-options-wrapper {
          padding-top: 24px;

          .Select-control {
            cursor: pointer;
          }

          .Select-menu-outer {
            max-height: none;

            .Select-menu {
              min-height: 255px;
            }
          }
        }
        &.industry-selected {
          padding-top: 5vh;
        }
      }

      .manage-question-wrapper {
        padding-top: 60px;
        display: flex;
        align-items: center;
        flex-direction: column;
        opacity: 0;
        transition: opacity 0.2s ease-in-out;

        .select-disclaimer {
          font-size: 0.875rem;
          font-weight: 300;
          text-align: center;
          padding-top: 16px;
        }
        .manage-options-question {
          font-size: 1.375rem;
          padding-top: 16px;
          text-align: center;
          strong {
            font-weight: bold;
          }
        }

        &.visible {
          opacity: 1;
        }
      }
    }

    .next-wrapper {
      align-items: center;
      display: flex;

      font-size: 1rem;
      letter-spacing: -0.01em;
      line-height: 30px;
      color: ${colors["brand-blue"]};
      opacity: 0;
      transition: opacity 0.2s;
      svg {
        fill: ${colors["brand-blue"]};
      }

      &.visible {
        opacity: 1;
      }

      .next-link {
        display: flex;
        flex-direction: column;
        align-items: center;

        .next-circle {
          background: rgba(43, 185, 255, 1);
          box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
          width: 28px;
          height: 28px;
          border-radius: 50%;
          color: white;
          font-size: 1.125rem;
          line-height: 24px;
          text-align: center;

          .arrow {
            padding-top: 2px;
            padding-left: 2px;
          }

          svg {
            fill: white;
          }
        }
      }
    }
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .industry-selection-first-step-wrapper {
    }
  }
`;

export const stepNumberStyles = css`
  .step-number-circle {
    border: 1px solid rgba(43, 185, 255, 1);
    width: 28px;
    height: 28px;
    border-radius: 50%;
    color: rgba(43, 185, 255, 1);
    font-size: 1.125rem;
    line-height: 24px;
    text-align: center;
  }
`;
